module.exports = __webpack_public_path__ + "static/media/bee-book-contents.82660d92.png";